var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',[_c('el-menu',{attrs:{"default-active":_vm.activeIndex,"mode":"horizontal","router":""}},[_c('el-menu-item',{attrs:{"index":"/"}},[_vm._v("问题单管理")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/config"}},[_vm._v("系统配置")])],1)],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 240
// module chunks = 1